import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { StartSurveyRPC } from "./startSurveyRPC";

export class StartSurveyRPCClientImpl extends StartSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: StartSurveyRPC.Request): Promise<LeoRPCResult<StartSurveyRPC.Response, StartSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey-respondent/StartSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      StartSurveyRPC.ResponseDTO,
      StartSurveyRPC.Errors.ErrorsDTO,
      StartSurveyRPC.Response,
      StartSurveyRPC.Errors.Errors
    >(
      response,
      "survey-respondent/StartSurvey",
      StartSurveyRPC.Response.fromDTO,
      StartSurveyRPC.Errors.fromDTO
    );
  }
}
